import http from '@/biz/http.mjs'

export default {
    read: args => http.get('/am/oneArchAm', args),
}
